export default __webpack_public_path__ + "static/media/Icon-Medical.a8789d9a.svg";